import React from "react";
import { QUIZ_RESULT_STATES } from "../constants";

function QuizCardResultText({ cardState }) {
  switch (cardState) {
    case QUIZ_RESULT_STATES.CORRECT:
      return (
        <p className="result-text">
          Good work! Click “Review” to further understand the correct answer.
        </p>
      );
    case QUIZ_RESULT_STATES.INCORRECT:
      return (
        <p className="result-text">
          You’ll get it next time! Click “Review” to understand the correct
          answer.
        </p>
      );
    case QUIZ_RESULT_STATES.SKIPPED:
      return (
        <p className="result-text">
          You skipped this question. Click “Review” to understand the correct
          answer.
        </p>
      );
    default:
      return null;
  }
}

export default QuizCardResultText;
